import { createFileRoute } from "@tanstack/react-router";
import PersonalityAssessmentInfo from "@/pages/PersonalityAssessmentInfo";
import { breadcrumbJsonLd } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/personality-assessment")({
  head: () =>
    seoHead({
      title: "Big Five Personality Assessment for Kids Ages 8–14",
      description:
        "Learn how the LeadXkids Big Five personality assessment compares child and parent perspectives, and preview the sample report.",
      canonical: "/personality-assessment",
      ogImage: "https://leadxkids.com/og-assessment.jpg",
      jsonLd: breadcrumbJsonLd([
        { name: "Home", url: "/" },
        { name: "Personality Assessment", url: "/personality-assessment" },
      ]),
    }),
  component: PersonalityAssessmentInfo,
});